import { render, staticRenderFns } from "./PaywallLimitModal.vue?vue&type=template&id=40497d0a&"
import script from "./PaywallLimitModal.vue?vue&type=script&lang=js&"
export * from "./PaywallLimitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports